// extracted by mini-css-extract-plugin
export default {"Container":"style_Container__en4UZ","Card":"style_Card__HzmaE","Icon":"style_Icon__DnoBI","options":"style_options__fIrV-","columns":"style_columns__zTv+T"};